import React from 'react'
import LocationRow from './LocationsRow'
import FooterSocialRow from './FooterSocialRow'
import FooterLinksRow from './FooterLinksRow'

import HorizontalDivider from '../elements/hDivider'

export default () => {
  return (
    <section className="mt-7 pb-7 overflow-hidden">
      <div className="bg-footer bg-nr bg-contain bg-p-c">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="font-alt mb-3 text-center">
                Our Locations
              </h2>
              <div className="divider bg-warning mx-auto"></div>
            </div>
          </div>
          <LocationRow/>
          <HorizontalDivider />
          <FooterSocialRow />
          <HorizontalDivider />
          <FooterLinksRow />
        </div>
      </div>
    </section>
  )
}